<template>
    <div class="container">
        <Title>Hilfe-System</Title>

        <div class="search mb-5">
            <input type="text" v-model="query" class="search__input" placeholder="Suche…">
        </div>

        <div v-if="query" class="mb">
            <h2 class="mb-5">Suchergebnisse</h2>
            <DocumentList :documents="documents"></DocumentList>

        </div>
        <div v-else>
            <h2 class="mb-5">Alle Dokumente</h2>
            <Category v-for="category in categories" :key="category" :id="category"></Category>
        </div>




    </div>
</template>

<script>
    import DocumentList from "../components/DocumentList.vue";
    import {DOCUMENTS_LOAD} from "../store/modules/documents";
    import {CATEGORIES_LOAD} from "../store/modules/categories";
    import Category from "../components/Category";
    import Title from "../ui/Title";
    import {SEARCH_QUERY_SET} from "../store/mutations";
    import Lightbox from "../components/Lightbox";

    export default {
        name: "home",
        components: {
            Title,
            Category,
            DocumentList,
        },

        computed: {

            query: {
                set(v) {
                    this.$store.commit(SEARCH_QUERY_SET, v);
                },

                get() {
                    return this.$store.state.searchQuery;
                }
            },

            categories() {
                return this.$store.getters.categories;
            },

            documents() {
                return this.$store.getters.documents(this.query ? 'search' : 'all')
            }
        },

        watch: {
            query() {
                this.$store.dispatch(DOCUMENTS_LOAD, {
                    mode: 'search',
                    filter: {query: this.query}
                })
            }
        },

    };
</script>

<style scoped>

    h2 {
        font-size: 2.2rem;
        line-height: 2.6rem;
        font-weight: normal;
        margin-bottom: 20px;
    }

    .search__input {
        display: block;
        width: 100%;

        padding: 1rem;
    }
</style>